import { Grid, Typography } from '@mui/material';
import React, { Dispatch, ReactElement, SetStateAction } from 'react';
import NotFound from '../../../common/components/NotFound';
import FormModal from '../../../common/form/FormModal';
import I18n from '../../../common/i18n/I18n';
import CrewImage from '../../../common/icons/IconImages/CrewImage';
import { H, V } from '../../../common/Layout';
import { useStyling } from '../../../common/Theme';

const ModalTitle = ({ title, length }: { title: string | ReactElement; length: number }) => {
    const { theme } = useStyling();
    return (
        <H>
            <Typography fontSize={20} color={theme.palette.text.secondary}>
                {title}
            </Typography>
            <Typography fontSize={18} color={theme.palette.text.disabled}>
                <I18n token={'length'} values={{ length: length }} />
            </Typography>
        </H>
    );
};

export default ({
    children,
    id,
    title,
    isModalOpen,
    setIsModalOpen
}: {
    children: ReactElement[];
    id: string;
    title: string | ReactElement;
    isModalOpen: boolean;
    setIsModalOpen: Dispatch<SetStateAction<boolean>>;
}) => {
    return (
        children && (
            <FormModal
                id={id}
                title={<ModalTitle title={title} length={children.length} />}
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                hideButtons
                sx={{
                    height: { xs: '100%', sm: 'fit-content' },
                    width: { xs: '100%', sm: '500px', md: '700px' },
                    maxHeight: { xs: '100%', sm: '550px' },
                    p: 1
                }}
                titleSx={{ p: 1, pb: 0 }}
                modalBodySx={{ p: 1 }}
            >
                {children.length ? (
                    <Grid container spacing={1.5} sx={{ flexGrow: 0 }}>
                        {children.map((c, index) => (
                            <Grid key={index} size={{ xs: 12, md: 6 }}>
                                {c}
                            </Grid>
                        ))}
                    </Grid>
                ) : (
                    <NotFound
                        ImageIcon={<CrewImage />}
                        title={<I18n token="no.results" />}
                        text={<I18n token="coming.soon" />}
                    />
                )}
            </FormModal>
        )
    );
};
